import React from 'react';
import Slider from 'react-slick';
import SwitchToLitCard from './location/switchToLitCard';
import { graphql, useStaticQuery } from 'gatsby';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
const WhySwitchToLit = ({ heading, switchData, backgroundColor }) => {
  return (
    <div
      className={`modular-header-image-heading-paragraph-content ${backgroundColor}`}
    >
      <LitStructuredText data={heading} basic />
      <div className="modular-header-image-heading-paragraph-inner">
        {switchData?.map(({ featureImage, heading, body }, index) => {
          return (
            <div className="header-image-heading-paragraph-content" key={index}>
              <div className="feature-image">
                <LitImage image={featureImage} alt="black and white icon" />
              </div>
              <LitStructuredText data={heading} basic />
              <LitStructuredText data={body} basic />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WhySwitchToLit;
